document.documentElement.classList.remove('no-js');

let cartToastTimerId;

function publishLineBossEvent(name, payload = {}) {
  try {
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(name, payload);
    }
  } catch (error) {}
  // Calculator interactions are also sent directly to GA4; Shopify custom
  // pixel events alone are not guaranteed to be forwarded to GA4.
  if (name === 'lineboss_calculator_started' || name === 'lineboss_calculator_pdf') {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, payload);
      }
    } catch (error) {}
  }
}

function showCartToast(message, type = 'success') {
  const toast = document.querySelector('[data-cart-toast]');
  const messageElement = toast?.querySelector('[data-cart-toast-message]');

  if (!toast || !messageElement) {
    return;
  }

  window.clearTimeout(cartToastTimerId);
  messageElement.textContent = message;
  toast.classList.toggle('is-error', type === 'error');
  toast.hidden = false;

  window.requestAnimationFrame(() => {
    toast.classList.add('is-visible');
  });

  cartToastTimerId = window.setTimeout(() => {
    toast.classList.remove('is-visible');

    window.setTimeout(() => {
      if (!toast.classList.contains('is-visible')) {
        toast.hidden = true;
      }
    }, 220);
  }, 3200);
}

function getCartAddUrl() {
  const rootUrl = window.Shopify?.routes?.root || '/';
  const rootPath = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
  return new URL(`${rootPath}cart/add.js`, window.location.origin).toString();
}

function getCartErrorMessage(response) {
  return response.json()
    .then((data) => {
      return data?.description || data?.message || 'Unable to add this item to the cart.';
    })
    .catch(() => 'Unable to add this item to the cart.');
}

function initMobileMenu() {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (!menuToggle || !mobileMenu) {
    return;
  }

  const submenuToggles = Array.from(
    mobileMenu.querySelectorAll('[data-mobile-submenu-toggle]'),
  );

  function setSubmenuState(toggle, open) {
    const item = toggle.closest('.mobile-nav-item');
    const submenuId = toggle.getAttribute('aria-controls');
    const submenu = submenuId ? document.getElementById(submenuId) : null;

    toggle.setAttribute('aria-expanded', String(open));
    item?.classList.toggle('is-open', open);

    if (submenu) {
      submenu.hidden = !open;
    }
  }

  function setMenuState(open) {
    menuToggle.setAttribute('aria-expanded', String(open));
    mobileMenu.classList.toggle('is-open', open);
    mobileMenu.hidden = !open;

    if (!open) {
      submenuToggles.forEach((toggle) => setSubmenuState(toggle, false));
    }
  }

  setMenuState(false);

  menuToggle.addEventListener('click', () => {
    setMenuState(menuToggle.getAttribute('aria-expanded') !== 'true');
  });

  submenuToggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      setSubmenuState(toggle, toggle.getAttribute('aria-expanded') !== 'true');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menuToggle.getAttribute('aria-expanded') === 'true') {
      setMenuState(false);
      menuToggle.focus();
    }
  });

  document.addEventListener('click', (event) => {
    if (
      menuToggle.getAttribute('aria-expanded') === 'true' &&
      !event.target.closest('[data-header]')
    ) {
      setMenuState(false);
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 1024 && menuToggle.getAttribute('aria-expanded') === 'true') {
      setMenuState(false);
    }
  });
}

function initDesktopSubmenus() {
  document.querySelectorAll('[data-nav-submenu-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      const item = toggle.closest('.nav-item');

      document.querySelectorAll('.nav-item.has-submenu.is-open').forEach((openItem) => {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          const openToggle = openItem.querySelector('[data-nav-submenu-toggle]');

          if (openToggle) {
            openToggle.setAttribute('aria-expanded', 'false');
          }
        }
      });

      toggle.setAttribute('aria-expanded', String(!expanded));

      if (item) {
        item.classList.toggle('is-open', !expanded);
      }
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.primary-nav')) {
      return;
    }

    document.querySelectorAll('.nav-item.has-submenu.is-open').forEach((item) => {
      item.classList.remove('is-open');
      const toggle = item.querySelector('[data-nav-submenu-toggle]');

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });
}

function initEyebrowRotators() {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-eyebrow-rotator]').forEach((rotator) => {
    if (rotator.dataset.rotatorReady === 'true') {
      return;
    }

    rotator.dataset.rotatorReady = 'true';

    const items = Array.from(rotator.querySelectorAll('[data-eyebrow-item]'));

    if (!items.length) {
      return;
    }

    let activeIndex = items.findIndex((item) => item.classList.contains('is-active'));

    if (activeIndex < 0) {
      activeIndex = 0;
    }

    function syncItems() {
      items.forEach((item, index) => {
        const isActive = index === activeIndex;

        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-hidden', String(!isActive));
        item.tabIndex = isActive ? 0 : -1;
      });
    }

    function setActiveIndex(index) {
      activeIndex = (index + items.length) % items.length;
      syncItems();
    }

    syncItems();

    if (items.length <= 1 || reducedMotion) {
      return;
    }

    const rotateDelay = Number(rotator.dataset.rotateDelay || '3600');
    let timerId;

    function stopRotation() {
      if (!timerId) {
        return;
      }

      window.clearInterval(timerId);
      timerId = undefined;
    }

    function startRotation() {
      if (timerId) {
        return;
      }

      timerId = window.setInterval(() => {
        setActiveIndex(activeIndex + 1);
      }, rotateDelay);
    }

    rotator.addEventListener('mouseenter', stopRotation);
    rotator.addEventListener('mouseleave', startRotation);
    rotator.addEventListener('focusin', stopRotation);
    rotator.addEventListener('focusout', (event) => {
      if (!rotator.contains(event.relatedTarget)) {
        startRotation();
      }
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopRotation();
      } else {
        startRotation();
      }
    });

    startRotation();
  });
}

function initContactFormFeedback() {
  document.querySelectorAll('form.contact-form').forEach((form) => {
    if (form.dataset.contactFormReady === 'true') {
      return;
    }

    form.dataset.contactFormReady = 'true';

    const toast = form.querySelector('[data-contact-form-toast]');
    const closeButton = toast.querySelector('[data-contact-form-toast-close]');
    const inlineSuccess = form.querySelector('[data-contact-form-inline-success]');
    let hideTimerId;
    let finishHideTimerId;

    function hideToast() {
      toast.classList.remove('is-visible');
      window.clearTimeout(hideTimerId);
      window.clearTimeout(finishHideTimerId);
      finishHideTimerId = window.setTimeout(() => {
        toast.hidden = true;
      }, 220);
    }

    function showToast() {
      toast.hidden = false;

      window.requestAnimationFrame(() => {
        toast.classList.add('is-visible');
      });

      window.clearTimeout(hideTimerId);
      hideTimerId = window.setTimeout(hideToast, 5000);
    }

    if (closeButton) {
      closeButton.addEventListener('click', hideToast);
    }

    if (inlineSuccess) {
      form.reset();
      showToast();
    }
  });
}

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function initGridLightSurfaces() {
  const surfaces = Array.from(document.querySelectorAll('[data-grid-light-surface]'));

  if (!surfaces.length) {
    return;
  }

  const finePointer = window.matchMedia('(pointer: fine)').matches;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const states = surfaces.map((surface, index) => {
    const rect = surface.getBoundingClientRect();
    const width = rect.width || surface.offsetWidth || 0;
    const height = rect.height || surface.offsetHeight || 0;
    const startX = width * 0.5;
    const startY = height * 0.4;

    surface.style.setProperty('--grid-light-x', `${startX}px`);
    surface.style.setProperty('--grid-light-y', `${startY}px`);

    return {
      surface,
      width,
      height,
      x: startX,
      y: startY,
      targetX: startX,
      targetY: startY,
      lastPointerAt: 0,
      phase: index * 1.67
    };
  });

  function measureSurfaces() {
    states.forEach((state) => {
      const rect = state.surface.getBoundingClientRect();
      state.width = rect.width || state.surface.offsetWidth || state.width;
      state.height = rect.height || state.surface.offsetHeight || state.height;
      state.x = clamp(state.x, 0, state.width);
      state.y = clamp(state.y, 0, state.height);
      state.targetX = clamp(state.targetX, 0, state.width);
      state.targetY = clamp(state.targetY, 0, state.height);
    });
  }

  measureSurfaces();

  if (reducedMotion) {
    return;
  }

  function handlePointerMove(event) {
    const now = performance.now();
    const capturePadding = 120;

    states.forEach((state) => {
      const rect = state.surface.getBoundingClientRect();
      const insideX = event.clientX >= rect.left - capturePadding && event.clientX <= rect.right + capturePadding;
      const insideY = event.clientY >= rect.top - capturePadding && event.clientY <= rect.bottom + capturePadding;

      if (!insideX || !insideY) {
        return;
      }

      state.targetX = clamp(event.clientX - rect.left, 0, rect.width);
      state.targetY = clamp(event.clientY - rect.top, 0, rect.height);
      state.lastPointerAt = now;
    });
  }

  if (finePointer) {
    window.addEventListener('mousemove', handlePointerMove, { passive: true });
  }

  window.addEventListener('resize', measureSurfaces, { passive: true });

  function animate(time) {
    const driftTime = time * 0.00018;

    states.forEach((state) => {
      if (!finePointer || time - state.lastPointerAt > 1500) {
        state.targetX = state.width * (0.18 + 0.64 * (0.5 + 0.5 * Math.sin(driftTime + state.phase)));
        state.targetY = state.height * (0.2 + 0.58 * (0.5 + 0.5 * Math.cos((driftTime * 1.24) + (state.phase * 1.18))));
      }

      state.x += (state.targetX - state.x) * 0.055;
      state.y += (state.targetY - state.y) * 0.055;

      state.surface.style.setProperty('--grid-light-x', `${state.x.toFixed(1)}px`);
      state.surface.style.setProperty('--grid-light-y', `${state.y.toFixed(1)}px`);
    });

    window.requestAnimationFrame(animate);
  }

  window.requestAnimationFrame(animate);
}

function initParallaxMedia() {
  const items = Array.from(document.querySelectorAll('[data-parallax-media]'));
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!items.length || reducedMotion) {
    return;
  }

  function update() {
    const viewportHeight = window.innerHeight || 1;

    items.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const progress = ((rect.top + rect.height * 0.5) / viewportHeight) - 0.5;
      const offset = clamp(progress * -42, -42, 42);

      item.style.setProperty('--parallax-offset', `${offset.toFixed(1)}px`);
    });
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
}

function initProductGalleries() {
  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const familySlides = slides.filter((slide) => slide.hasAttribute('data-gallery-family'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    const prevButton = gallery.querySelector('[data-gallery-prev]');
    const nextButton = gallery.querySelector('[data-gallery-next]');

    if (!slides.length) {
      return;
    }

    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));

    function syncGallery() {
      const activeSlide = slides[activeIndex];

      slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === activeIndex);
      });

      thumbs.forEach((thumb) => {
        const isActive = Boolean(activeSlide?.dataset.mediaId && thumb.dataset.mediaId === activeSlide.dataset.mediaId);
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', String(isActive));
      });

      if (prevButton) {
        prevButton.disabled = familySlides.length <= 1;
      }

      if (nextButton) {
        nextButton.disabled = familySlides.length <= 1;
      }
    }

    function setActiveIndex(index) {
      if (!slides.length) {
        return;
      }

      activeIndex = (index + slides.length) % slides.length;
      syncGallery();
    }

    function setActiveFamilyOffset(offset) {
      if (!familySlides.length) {
        return;
      }

      const activeSlide = slides[activeIndex];
      const activeFamilyIndex = familySlides.findIndex((slide) => slide === activeSlide);
      const nextFamilyIndex =
        activeFamilyIndex >= 0
          ? activeFamilyIndex + offset
          : offset >= 0
            ? 0
            : familySlides.length - 1;
      const nextSlide = familySlides[(nextFamilyIndex + familySlides.length) % familySlides.length];
      const nextIndex = slides.findIndex((slide) => slide === nextSlide);

      if (nextIndex >= 0) {
        setActiveIndex(nextIndex);
      }
    }

    gallery.setActiveMedia = (mediaId, imageId) => {
      if (!mediaId && !imageId) {
        return;
      }

      const targetIndex = slides.findIndex((slide) => {
        if (mediaId && slide.dataset.mediaId === String(mediaId)) {
          return true;
        }

        if (imageId && slide.dataset.imageId === String(imageId)) {
          return true;
        }

        return false;
      });

      if (targetIndex >= 0) {
        setActiveIndex(targetIndex);
      }
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const targetIndex = slides.findIndex((slide) => slide.dataset.mediaId === thumb.dataset.mediaId);

        if (targetIndex >= 0) {
          setActiveIndex(targetIndex);
        }
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', () => setActiveFamilyOffset(-1));
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => setActiveFamilyOffset(1));
    }

    syncGallery();
  });
}

function initVariantPills() {
  document.querySelectorAll('.product-form--variant-pills').forEach((form) => {
    const productRoot = form.closest('.product-template');
    const priceElement = productRoot?.querySelector('[data-product-price]');
    const compareElement = productRoot?.querySelector('[data-product-compare]');
    const priceKgElement = productRoot?.querySelector('[data-product-price-kg]');
    const selectedVariantLabel = productRoot?.querySelector('[data-selected-variant-label]');
    const stickyPriceElements = Array.from(productRoot?.querySelectorAll('[data-product-sticky-price]') || []);
    const submitButtons = Array.from(form.querySelectorAll('[data-product-submit]'));
    const radios = Array.from(form.querySelectorAll('[data-variant-radio]'));
    const gallery = productRoot?.querySelector('[data-product-gallery]');

    if (!priceElement || !submitButtons.length || !radios.length) {
      return;
    }

    function updateVariantState(radio) {
      if (!radio) {
        return;
      }

      priceElement.textContent = radio.dataset.price || '';
      priceElement.setAttribute('content', radio.dataset.priceRaw || '');

      if (priceKgElement) {
        priceKgElement.textContent = radio.dataset.priceKg || '';
      }

      if (selectedVariantLabel) {
        selectedVariantLabel.textContent = radio.dataset.variantTitle || '';
      }

      stickyPriceElements.forEach((element) => {
        element.textContent = radio.dataset.price || '';
      });

      const compareRaw = Number(radio.dataset.compareRaw || '0');
      const priceRaw = Number(radio.dataset.priceRaw || '0');
      const available = radio.dataset.available === 'true';

      if (compareElement) {
        if (compareRaw > priceRaw) {
          compareElement.textContent = radio.dataset.compare || '';
          compareElement.hidden = false;
          compareElement.classList.remove('is-hidden');
        } else {
          compareElement.textContent = '';
          compareElement.hidden = true;
          compareElement.classList.add('is-hidden');
        }
      }

      submitButtons.forEach((button) => {
        button.disabled = !available;
        button.textContent = available ? (button.dataset.addLabel || 'Add to cart') : (button.dataset.soldLabel || 'Sold out');
      });

      if (gallery && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(radio.dataset.mediaId, radio.dataset.imageId);
      }
    }

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        updateVariantState(radio);
        publishLineBossEvent('lineboss_variant_selected', {
          product: productRoot?.querySelector('h1')?.textContent?.trim() || '',
          variant: radio.dataset.variantTitle || '',
        });
      });
    });

    updateVariantState(radios.find((radio) => radio.checked) || radios[0]);
  });
}

function initCommercialLicenseProducts() {
  document.querySelectorAll('[data-commercial-license-product]').forEach((root) => {
    const form = root.querySelector('form');
    const priceElement = root.querySelector('[data-product-price]');
    const compareElement = root.querySelector('[data-product-compare]');
    const variantRadios = Array.from(root.querySelectorAll('[data-variant-radio]'));
    const planGroups = Array.from(root.querySelectorAll('[data-selling-plan-variant]'));
    const planRadios = Array.from(root.querySelectorAll('[data-selling-plan-radio]'));
    const hiddenVariantInput = form?.querySelector('input[name="id"][type="hidden"]');

    if (!priceElement || !planGroups.length || !planRadios.length) {
      return;
    }

    function getActiveVariantId() {
      const checkedVariant = variantRadios.find((radio) => radio.checked);

      return checkedVariant?.value || hiddenVariantInput?.value || planGroups[0]?.dataset.variantId || '';
    }

    function getActivePlanGroup() {
      const activeVariantId = getActiveVariantId();

      return planGroups.find((group) => group.dataset.variantId === activeVariantId) || planGroups[0];
    }

    function updatePrice(planRadio) {
      if (!planRadio) {
        return;
      }

      priceElement.textContent = planRadio.dataset.price || priceElement.textContent;
      priceElement.setAttribute('content', planRadio.dataset.priceRaw || '');

      const compareRaw = Number(planRadio.dataset.compareRaw || '0');
      const priceRaw = Number(planRadio.dataset.priceRaw || '0');

      if (compareElement) {
        if (compareRaw > priceRaw) {
          compareElement.textContent = planRadio.dataset.compare || '';
          compareElement.hidden = false;
          compareElement.classList.remove('is-hidden');
        } else {
          compareElement.textContent = '';
          compareElement.hidden = true;
          compareElement.classList.add('is-hidden');
        }
      }
    }

    function syncPlanSelection() {
      const activeVariantId = getActiveVariantId();

      planGroups.forEach((group) => {
        const isActive = !activeVariantId || group.dataset.variantId === activeVariantId;

        group.hidden = !isActive;
        group.classList.toggle('is-active', isActive);

        group.querySelectorAll('[data-selling-plan-radio]').forEach((radio) => {
          radio.disabled = !isActive || radio.dataset.variantAvailable === 'false';
        });
      });

      const activeGroup = getActivePlanGroup();
      const availablePlans = Array.from(activeGroup.querySelectorAll('[data-selling-plan-radio]')).filter((radio) => !radio.disabled);
      let activePlan = availablePlans.find((radio) => radio.checked);

      if (!activePlan && availablePlans.length) {
        activePlan = availablePlans[0];
        activePlan.checked = true;
      }

      updatePrice(activePlan);
    }

    variantRadios.forEach((radio) => {
      radio.addEventListener('change', syncPlanSelection);
    });

    planRadios.forEach((radio) => {
      radio.addEventListener('change', () => updatePrice(radio));
    });

    syncPlanSelection();
  });
}

function initAjaxProductForms() {
  document.querySelectorAll('.product-form--variant-pills').forEach((form) => {
    if (form.dataset.ajaxCartReady === 'true') {
      return;
    }

    const submitButtons = Array.from(form.querySelectorAll('[data-product-submit]'));
    const submitButton = submitButtons[0];

    if (!submitButtons.length || !submitButton) {
      return;
    }

    form.dataset.ajaxCartReady = 'true';

    form.addEventListener('submit', (event) => {
      if (submitButton.disabled) {
        return;
      }

      event.preventDefault();

      const originalLabels = submitButtons.map((button) => button.textContent.trim());

      submitButtons.forEach((button) => {
        button.disabled = true;
        button.textContent = 'Adding...';
      });

      fetch(getCartAddUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        },
        body: new FormData(form)
      })
        .then(async (response) => {
          if (!response.ok) {
            throw new Error(await getCartErrorMessage(response));
          }

          return response.json();
        })
        .then((item) => {
          showCartToast('Added to cart successfully');
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { item }
          }));
        })
        .catch((error) => {
          showCartToast(error.message || 'Unable to add this item to the cart.', 'error');
        })
        .finally(() => {
          submitButtons.forEach((button, index) => {
            button.disabled = false;
            button.textContent = originalLabels[index] || button.dataset.addLabel || 'Add to cart';
          });
        });
    });
  });
}

function initStarterCartForms() {
  document.querySelectorAll('[data-starter-cart-form]').forEach((form) => {
    if (form.dataset.starterCartReady === 'true') {
      return;
    }

    const submitButton = form.querySelector('[data-starter-cart-submit]');
    const itemInputs = Array.from(form.querySelectorAll('[data-starter-cart-item]'));

    if (!submitButton || itemInputs.length < 4) {
      return;
    }

    form.dataset.starterCartReady = 'true';

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (submitButton.disabled) {
        return;
      }

      const seenIds = new Set();
      const items = itemInputs
        .map((input) => Number(input.value))
        .filter((id) => {
          if (!id || seenIds.has(id)) {
            return false;
          }

          seenIds.add(id);
          return true;
        })
        .map((id) => ({ id, quantity: 1 }));

      if (items.length < 4) {
        showCartToast('Choose starter colors from the PLA collection.', 'error');
        return;
      }

      const originalLabel = submitButton.textContent.trim();
      submitButton.disabled = true;
      submitButton.textContent = 'Adding...';

      fetch(getCartAddUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      })
        .then(async (response) => {
          if (!response.ok) {
            throw new Error(await getCartErrorMessage(response));
          }

          return response.json();
        })
        .then((cartItems) => {
          showCartToast('Starter cart added');
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { items: cartItems }
          }));
        })
        .catch((error) => {
          showCartToast(error.message || 'Unable to add starter cart.', 'error');
        })
        .finally(() => {
          submitButton.disabled = false;
          submitButton.textContent = originalLabel;
        });
    });
  });
}

function initCartDiscountValidation() {
  const field = document.querySelector('[data-cart-discount-field]');

  if (!field || field.dataset.cartDiscountReady === 'true') {
    return;
  }

  const input = field.querySelector('[data-cart-discount-input]');
  const applyButton = field.querySelector('[data-cart-discount-apply]');
  const message = field.parentElement?.querySelector('[data-cart-discount-message]');

  if (!input || !applyButton || !message) {
    return;
  }

  field.dataset.cartDiscountReady = 'true';
  const storageKey = 'lineboss.cartDiscountCode';

  function getCartUrl() {
    const rootUrl = window.Shopify?.routes?.root || '/';
    const rootPath = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
    return new URL(`${rootPath}cart.js`, window.location.origin).toString();
  }

  function getCartUpdateUrl() {
    const rootUrl = window.Shopify?.routes?.root || '/';
    const rootPath = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
    return new URL(`${rootPath}cart/update.js`, window.location.origin).toString();
  }

  function getStoredDiscountCode() {
    try {
      return window.sessionStorage.getItem(storageKey) || '';
    } catch (error) {
      return '';
    }
  }

  function setStoredDiscountCode(code) {
    try {
      if (code) {
        window.sessionStorage.setItem(storageKey, code);
      } else {
        window.sessionStorage.removeItem(storageKey);
      }
    } catch (error) {}
  }

  function normalizeCode(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getCartDiscountApplications(cart) {
    const applications = [
      ...(cart?.cart_level_discount_applications || []),
      ...(cart?.discount_applications || [])
    ];

    (cart?.items || []).forEach((item) => {
      applications.push(...(item.discounts || []));
      (item.discount_allocations || []).forEach((allocation) => {
        if (allocation.discount_application) {
          applications.push(allocation.discount_application);
        }
      });
    });

    return applications;
  }

  function discountApplicationMatchesCode(application, code) {
    if (!application || application.applicable === false) {
      return false;
    }

    return ['code', 'title', 'key'].some((property) => {
      return normalizeCode(application[property]) === code;
    });
  }

  function cartHasDiscountCode(cart, code) {
    const normalizedCode = normalizeCode(code);

    if (!normalizedCode) {
      return false;
    }

    const discountCodes = cart?.discount_codes || [];
    const hasApplicableCode = discountCodes.some((discount) => {
      return discount.applicable === true && normalizeCode(discount.code) === normalizedCode;
    });

    return hasApplicableCode || getCartDiscountApplications(cart).some((application) => {
      return discountApplicationMatchesCode(application, normalizedCode);
    });
  }

  function getConfirmedDiscountCode(cart, preferredCode = '') {
    const normalizedPreferredCode = normalizeCode(preferredCode);
    const applicableCodes = (cart?.discount_codes || [])
      .filter((discount) => discount.applicable === true && discount.code)
      .map((discount) => discount.code);

    if (normalizedPreferredCode) {
      const preferredMatch = applicableCodes.find((code) => normalizeCode(code) === normalizedPreferredCode);

      if (preferredMatch || cartHasDiscountCode(cart, preferredCode)) {
        return preferredMatch || preferredCode;
      }
    }

    return applicableCodes[0] || '';
  }

  function setMessage(text, type) {
    message.textContent = text;
    message.classList.toggle('is-success', type === 'success');
    message.classList.toggle('is-error', type === 'error');
  }

  function applyDiscount(codeOverride) {
    const code = String(codeOverride || input.value).trim();

    if (!code) {
      setMessage('Enter a discount code to apply.', 'error');
      input.focus();
      return;
    }

    const originalLabel = applyButton.textContent;
    applyButton.disabled = true;
    applyButton.textContent = 'Applying...';
    setMessage('', '');

    fetch(getCartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: code })
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Unable to apply this discount code.');
        }

        return response.json();
      })
      .then((cart) => {
        if (cartHasDiscountCode(cart, code)) {
          const confirmedCode = getConfirmedDiscountCode(cart, code) || code;
          input.value = confirmedCode;
          setStoredDiscountCode(confirmedCode);
          setMessage(`${confirmedCode} is applied and will carry into checkout.`, 'success');
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart }
          }));
        } else {
          setStoredDiscountCode('');
          setMessage('That code was not applied. Check the spelling or try another code.', 'error');
        }
      })
      .catch((error) => {
        setMessage(error.message || 'Unable to apply this discount code.', 'error');
      })
      .finally(() => {
        applyButton.disabled = false;
        applyButton.textContent = originalLabel;
      });
  }

  function restoreDiscountState() {
    const storedCode = getStoredDiscountCode();

    fetch(getCartUrl(), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Unable to refresh discount state.');
        }

        return response.json();
      })
      .then((cart) => {
        const confirmedCode = getConfirmedDiscountCode(cart, storedCode);

        if (confirmedCode) {
          input.value = confirmedCode;
          setStoredDiscountCode(confirmedCode);
          setMessage(`${confirmedCode} is applied and will carry into checkout.`, 'success');
          return;
        }

        if (storedCode) {
          input.value = storedCode;
          applyDiscount(storedCode);
        }
      })
      .catch(() => {
        if (storedCode && !input.value) {
          input.value = storedCode;
        }
      });
  }

  applyButton.addEventListener('click', () => applyDiscount());
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      applyDiscount();
    }
  });
  restoreDiscountState();
}

function initBlogHub() {
  document.querySelectorAll('[data-blog-hub]').forEach((hub) => {
    const tabs = Array.from(hub.querySelectorAll('[data-blog-nav]'));
    const panels = Array.from(hub.querySelectorAll('[data-blog-panel]'));

    if (!tabs.length || !panels.length) {
      return;
    }

    function setActivePanel(targetId) {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.blogTarget === targetId;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      panels.forEach((panel) => {
        const isActive = panel.id === targetId;

        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        setActivePanel(tab.dataset.blogTarget);
      });

      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
          return;
        }

        event.preventDefault();

        const nextIndex = event.key === 'ArrowDown'
          ? (index + 1) % tabs.length
          : (index - 1 + tabs.length) % tabs.length;

        tabs[nextIndex].focus();
        setActivePanel(tabs[nextIndex].dataset.blogTarget);
      });
    });

    const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
    setActivePanel(activeTab.dataset.blogTarget);
  });
}

function initLaunchCountdowns() {
  document.querySelectorAll('[data-countdown-target]').forEach((countdown) => {
    const targetRaw = countdown.dataset.countdownTarget;

    if (!targetRaw) {
      return;
    }

    const targetTime = new Date(targetRaw).getTime();

    if (Number.isNaN(targetTime)) {
      return;
    }

    const daysElement = countdown.querySelector('[data-countdown-days]');
    const hoursElement = countdown.querySelector('[data-countdown-hours]');
    const minutesElement = countdown.querySelector('[data-countdown-minutes]');
    const secondsElement = countdown.querySelector('[data-countdown-seconds]');

    function setValue(element, value) {
      if (!element) {
        return;
      }

      element.textContent = String(value).padStart(2, '0');
    }

    function updateCountdown() {
      const remainingMs = Math.max(0, targetTime - Date.now());
      const totalSeconds = Math.floor(remainingMs / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      setValue(daysElement, days);
      setValue(hoursElement, hours);
      setValue(minutesElement, minutes);
      setValue(secondsElement, seconds);
    }

    updateCountdown();
    window.setInterval(updateCountdown, 1000);
  });
}

function initSlicerSettings() {
  document.querySelectorAll('[data-slicer-library]').forEach((library) => {
    if (library.dataset.slicerLibraryReady === 'true') {
      return;
    }

    library.dataset.slicerLibraryReady = 'true';

    const cards = Array.from(library.querySelectorAll('[data-profile-card]'));
    const filters = Array.from(library.querySelectorAll('[data-profile-filter]'));
    const countElement = library.querySelector('[data-profile-count]');
    const emptyElement = library.querySelector('[data-profile-empty]');

    if (!cards.length || !filters.length) {
      return;
    }

    const activeFilters = {
      material: 'all',
      slicer: 'all'
    };

    function updateCount(visibleCount) {
      if (!countElement) {
        return;
      }

      const noun = visibleCount === 1 ? 'profile' : 'profiles';
      countElement.textContent = `${visibleCount} ${noun} ready`;
    }

    function applyFilters() {
      let visibleCount = 0;

      cards.forEach((card) => {
        const materialMatches = activeFilters.material === 'all' || card.dataset.material === activeFilters.material;
        const slicerMatches = activeFilters.slicer === 'all' || card.dataset.slicer === activeFilters.slicer;
        const isVisible = materialMatches && slicerMatches;

        card.hidden = !isVisible;

        if (isVisible) {
          visibleCount += 1;
        }
      });

      updateCount(visibleCount);

      if (emptyElement) {
        emptyElement.hidden = visibleCount > 0;
      }
    }

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        const type = filter.dataset.filterType;
        const value = filter.dataset.filterValue || 'all';

        if (!type || !(type in activeFilters)) {
          return;
        }

        activeFilters[type] = value;

        filters
          .filter((item) => item.dataset.filterType === type)
          .forEach((item) => {
            const isActive = item === filter;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', String(isActive));
          });

        applyFilters();
      });
    });

    applyFilters();
  });
}

function initCartCountRefresh() {
  const countElements = Array.from(document.querySelectorAll('[data-cart-count]'));
  const cartLinks = Array.from(document.querySelectorAll('[data-cart-link]'));
  const floatingCartButtons = Array.from(document.querySelectorAll('[data-floating-cart]'));

  if (!countElements.length) {
    return;
  }

  let refreshPromise;
  let refreshTimerId;

  function getCartUrl() {
    const rootUrl = window.Shopify?.routes?.root || '/';
    const rootPath = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
    return new URL(`${rootPath}cart.js`, window.location.origin).toString();
  }

  function getRequestUrl(input) {
    if (typeof input === 'string') {
      return input;
    }

    if (input?.url) {
      return input.url;
    }

    if (input?.href) {
      return input.href;
    }

    return '';
  }

  function isCartMutationUrl(input) {
    const requestUrl = getRequestUrl(input);

    if (!requestUrl) {
      return false;
    }

    try {
      const url = new URL(requestUrl, window.location.origin);
      return /(^|\/)cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname.replace(/\/+$/, ''));
    } catch (error) {
      return false;
    }
  }

  function updateCartCount(itemCount) {
    const count = Number(itemCount) || 0;
    const label = count === 1 ? 'item' : 'items';

    countElements.forEach((element) => {
      element.textContent = String(count);
    });

    cartLinks.forEach((link) => {
      link.setAttribute('aria-label', `Cart, ${count} ${label}`);
    });

    floatingCartButtons.forEach((button) => {
      button.hidden = count <= 0;
    });
  }

  function refreshCartCount() {
    if (refreshPromise) {
      return refreshPromise;
    }

    refreshPromise = fetch(getCartUrl(), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Unable to refresh cart count');
        }

        return response.json();
      })
      .then((cart) => updateCartCount(cart.item_count))
      .catch(() => {})
      .finally(() => {
        refreshPromise = undefined;
      });

    return refreshPromise;
  }

  function scheduleCartCountRefresh(delay = 120) {
    window.clearTimeout(refreshTimerId);
    refreshTimerId = window.setTimeout(refreshCartCount, delay);
  }

  ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build'].forEach((eventName) => {
    document.addEventListener(eventName, () => scheduleCartCountRefresh(0));
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      scheduleCartCountRefresh(0);
    }
  });

  if (window.fetch && !window.fetch.linebossCartCountPatched) {
    const originalFetch = window.fetch.bind(window);

    const patchedFetch = (...args) => {
      const shouldRefresh = isCartMutationUrl(args[0]);

      return originalFetch(...args).then((response) => {
        if (shouldRefresh && response.ok) {
          scheduleCartCountRefresh();
        }

        return response;
      });
    };

    patchedFetch.linebossCartCountPatched = true;
    window.fetch = patchedFetch;
  }

  if (window.XMLHttpRequest && !window.XMLHttpRequest.prototype.linebossCartCountPatched) {
    const originalOpen = window.XMLHttpRequest.prototype.open;

    window.XMLHttpRequest.prototype.open = function open(method, url, ...rest) {
      const shouldRefresh = isCartMutationUrl(url);

      if (shouldRefresh) {
        this.addEventListener('loadend', () => {
          if (this.status >= 200 && this.status < 400) {
            scheduleCartCountRefresh();
          }
        }, { once: true });
      }

      return originalOpen.call(this, method, url, ...rest);
    };

    window.XMLHttpRequest.prototype.linebossCartCountPatched = true;
  }
}

function initPolicyPage() {
  const container = document.querySelector('.shopify-policy__container');

  if (!container) {
    return;
  }

  const title = container.querySelector('.shopify-policy__title h1, h1');
  const body = container.querySelector('.shopify-policy__body .rte, .shopify-policy__body');

  if (!title || !body) {
    return;
  }

  const firstTextBlock = body.querySelector(':scope > h1, :scope > h2, :scope > h3, :scope > p');

  if (!firstTextBlock) {
    return;
  }

  const titleText = title.textContent.trim().toLowerCase();
  const firstText = firstTextBlock.textContent.trim().toLowerCase();

  if (titleText && titleText === firstText) {
    firstTextBlock.remove();
  }
}

function initAccountSessionModal() {
  const modal = document.querySelector('[data-account-session-modal]');

  if (!modal || modal.dataset.accountSessionModalReady === 'true') {
    return;
  }

  if (window.Shopify && window.Shopify.designMode) {
    return;
  }

  modal.dataset.accountSessionModalReady = 'true';

  const storageKey = 'lineboss.accountPrompt.dismissedUntil';
  const suppressionWindow = 7 * 24 * 60 * 60 * 1000;
  const dialog = modal.querySelector('.account-session-modal__dialog');
  const closeControls = modal.querySelectorAll('[data-account-session-modal-close]');
  const actionLinks = modal.querySelectorAll('[data-account-session-modal-action]');
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  let opener;
  let hideTimerId;

  function isSuppressed() {
    try {
      return Number(window.localStorage.getItem(storageKey) || 0) > Date.now();
    } catch (error) {
      return false;
    }
  }

  function suppressPrompt() {
    try {
      window.localStorage.setItem(storageKey, String(Date.now() + suppressionWindow));
    } catch (error) {}
  }

  function getFocusableElements() {
    if (!dialog) {
      return [];
    }

    return Array.from(dialog.querySelectorAll(focusableSelector)).filter((element) => {
      return element.offsetParent !== null || element === document.activeElement;
    });
  }

  function focusDialog() {
    const focusable = getFocusableElements();
    const target = focusable[0] || dialog;

    if (target) {
      target.focus({ preventScroll: true });
    }
  }

  function closeModal() {
    suppressPrompt();
    window.clearTimeout(hideTimerId);
    modal.classList.remove('is-visible');
    document.body.classList.remove('account-session-modal-open');

    hideTimerId = window.setTimeout(() => {
      modal.hidden = true;

      if (opener && typeof opener.focus === 'function' && document.contains(opener)) {
        opener.focus({ preventScroll: true });
      }
    }, 220);
  }

  function handleKeydown(event) {
    if (modal.hidden) {
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') {
      return;
    }

    const focusable = getFocusableElements();

    if (!focusable.length) {
      event.preventDefault();
      focusDialog();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openModal() {
    if (isSuppressed()) {
      return;
    }

    suppressPrompt();
    opener = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('account-session-modal-open');

    window.requestAnimationFrame(() => {
      modal.classList.add('is-visible');
      window.setTimeout(focusDialog, 80);
    });
  }

  closeControls.forEach((control) => {
    control.addEventListener('click', closeModal);
  });

  actionLinks.forEach((link) => {
    link.addEventListener('click', suppressPrompt);
  });

  document.addEventListener('keydown', handleKeydown);
  window.setTimeout(openModal, 20000);
}

function initPricingCalculators() {
  document.querySelectorAll('[data-pricing-calculator]').forEach((calculator) => {
    if (calculator.dataset.calculatorReady === 'true') {
      return;
    }

    const form = calculator.querySelector('[data-calculator-form]');

    if (!form) {
      return;
    }

    calculator.dataset.calculatorReady = 'true';

    const fields = {};
    const state = {
      imageDataUrl: '',
      imageName: '',
      quoteNumber: createQuoteNumber(),
      values: null,
    };
    let calculatorStarted = false;

    calculator.querySelectorAll('[data-calc-field]').forEach((field) => {
      fields[field.dataset.calcField] = field;
    });

    const imageInput = calculator.querySelector('[data-calc-image]');
    const imagePreviewWrap = calculator.querySelector('[data-calc-image-preview-wrap]');
    const imagePreview = calculator.querySelector('[data-calc-image-preview]');
    const imageName = calculator.querySelector('[data-calc-image-name]');
    const imageError = calculator.querySelector('[data-calc-image-error]');
    const imageRemove = calculator.querySelector('[data-calc-image-remove]');

    function createQuoteNumber() {
      const now = new Date();
      const date = [now.getFullYear(), String(now.getMonth() + 1).padStart(2, '0'), String(now.getDate()).padStart(2, '0')].join('');
      let suffix = Math.floor(Math.random() * 0xffff).toString(16).toUpperCase().padStart(4, '0');

      if (window.crypto?.getRandomValues) {
        const random = new Uint16Array(1);
        window.crypto.getRandomValues(random);
        suffix = random[0].toString(16).toUpperCase().padStart(4, '0');
      }

      return `LBQ-${date}-${suffix}`;
    }

    function numberValue(name, maximum = Number.POSITIVE_INFINITY) {
      const input = fields[name];
      const parsed = Number.parseFloat(input?.value || '0');
      const value = Number.isFinite(parsed) ? Math.min(Math.max(parsed, 0), maximum) : 0;

      if (input) {
        const isValid = Number.isFinite(parsed) && parsed >= 0 && parsed <= maximum;
        input.toggleAttribute('aria-invalid', !isValid);
      }

      return value;
    }

    function moneyFormatter(currency) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      } catch (_error) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    }

    function durationLabel(hours) {
      const totalMinutes = Math.round(hours * 60);
      const wholeHours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      if (!wholeHours) {
        return `${minutes} min`;
      }

      return minutes ? `${wholeHours} hr ${minutes} min` : `${wholeHours} hr`;
    }

    function decimalHoursLabel(hours) {
      return `${Number(hours.toFixed(2))} hr`;
    }

    function setOutput(name, value) {
      calculator.querySelectorAll(`[data-calc-output="${name}"]`).forEach((element) => {
        element.textContent = value;
      });
    }

    function setRow(selector, visible) {
      calculator.querySelectorAll(selector).forEach((row) => {
        row.hidden = !visible;
      });
    }

    function calculate() {
      const quantity = Math.max(1, Math.floor(numberValue('quantity', 10000) || 1));
      const materialRate = numberValue('materialRate');
      const grams = numberValue('grams');
      const printHours = numberValue('printHours') + (numberValue('printMinutes', 59) / 60);
      const designIncluded = fields.projectType?.value === 'designed';
      const designHours = designIncluded ? numberValue('designHours') : 0;
      const designRate = numberValue('designRate');
      const handsMinutes = numberValue('handsMinutes');
      const handsRate = numberValue('handsRate');
      const complexity = numberValue('complexity', 5) || 1;
      const shippingEnabled = Boolean(fields.shippingEnabled?.checked);
      const postage = shippingEnabled ? numberValue('postage') : 0;
      const packaging = shippingEnabled ? numberValue('packaging') : 0;
      const handling = shippingEnabled ? numberValue('handling') : 0;
      const platformFeeRate = shippingEnabled ? numberValue('platformFee', 95) / 100 : 0;
      const wearRate = numberValue('wearRate');
      const utilityRate = numberValue('utilityRate');
      const maintenanceRate = numberValue('maintenanceRate');
      const minimumProductionRate = numberValue('minimumProductionRate');
      const failureRate = numberValue('failureRate', 95) / 100;
      const marginRate = numberValue('marginRate', 95) / 100;
      if (!window.LineBossPricing?.calculateQuote) {
        return;
      }

      const pricing = window.LineBossPricing.calculateQuote({
        materialRate,
        grams,
        printHours,
        designIncluded,
        designHours,
        designRate,
        handsMinutes,
        handsRate,
        complexity,
        shippingEnabled,
        postage,
        packaging,
        handling,
        platformFeeRate,
        wearRate,
        utilityRate,
        maintenanceRate,
        minimumProductionRate,
        failureRate,
        marginRate,
        quantity,
      });
      const {
        materialCost,
        machineWear,
        utilities,
        maintenance,
        failureReserve,
        protectedProduction,
        designLabor,
        handsLabor,
        processorFee,
        materialCharge,
        productionCharge,
        designCharge,
        handsCharge,
        shippingCharge,
        trueCost,
        total,
        perUnit,
        grossProfit,
        actualMargin,
        belowTargetMargin,
        targetMarginPercent,
      } = pricing;
      const currency = fields.currency?.value || 'USD';
      const formatter = moneyFormatter(currency);
      const complexityLabel = fields.complexity?.selectedOptions?.[0]?.textContent?.trim() || `${complexity.toFixed(2)}x`;
      const projectTypeLabel = fields.projectType?.selectedOptions?.[0]?.textContent?.trim() || 'Print Only';
      const projectName = fields.projectName?.value.trim() || 'Untitled project';
      const customerName = fields.customerName?.value.trim() || '—';
      const projectNotes = fields.projectNotes?.value.trim() || '';
      const complexityReason = fields.complexityReason?.value || 'Project requirements';

      state.values = {
        currency,
        formatter,
        projectName,
        customerName,
        projectNotes,
        projectTypeLabel,
        complexityLabel,
        complexityReason,
        complexity,
        grams,
        printHours,
        designHours,
        handsMinutes,
        marginRate,
        quantity,
        materialCost,
        machineWear,
        utilities,
        maintenance,
        failureReserve,
        protectedProduction,
        designLabor,
        handsLabor,
        postage,
        packaging,
        handling,
        processorFee,
        materialCharge,
        productionCharge,
        designCharge,
        handsCharge,
        shippingCharge,
        trueCost,
        total,
        perUnit,
        grossProfit,
        actualMargin,
        belowTargetMargin,
        targetMarginPercent,
        designIncluded,
        shippingEnabled,
      };

      setOutput('total', formatter.format(total));
      setOutput('summary', `${projectTypeLabel} · ${complexityLabel.split(' — ')[0]}`);
      setOutput('projectTitle', projectName);
      setOutput('quoteNumber', state.quoteNumber);
      setOutput('quoteNumberInternal', state.quoteNumber);
      setOutput('projectType', projectTypeLabel);
      setOutput('customerName', customerName);
      setOutput('quantity', String(quantity));
      setOutput('materialDetail', `${Math.round(grams)} g`);
      setOutput('materialCharge', formatter.format(materialCharge));
      setOutput('productionDetail', durationLabel(printHours));
      setOutput('productionCharge', formatter.format(productionCharge));
      setOutput('designDetail', decimalHoursLabel(designHours));
      setOutput('designCharge', formatter.format(designCharge));
      setOutput('handsDetail', `${Math.round(handsMinutes)} min`);
      setOutput('handsCharge', formatter.format(handsCharge));
      setOutput('complexityReason', complexityReason);
      setOutput('complexityLabel', complexityLabel);
      setOutput('shippingCharge', formatter.format(shippingCharge));
      setOutput('customerTotal', formatter.format(total));
      setOutput('perUnit', formatter.format(perUnit));
      setOutput('projectNotes', projectNotes);
      setOutput('internalMaterial', formatter.format(materialCost));
      setOutput('internalQuantity', String(quantity));
      setOutput('internalGrams', `${Math.round(grams)} g`);
      setOutput('internalDuration', durationLabel(printHours));
      setOutput('machineWear', formatter.format(machineWear));
      setOutput('utilities', formatter.format(utilities));
      setOutput('maintenance', formatter.format(maintenance));
      setOutput('failureReserve', formatter.format(failureReserve));
      setOutput('protectedProduction', formatter.format(protectedProduction));
      setOutput('designLabor', formatter.format(designLabor));
      setOutput('handsLabor', formatter.format(handsLabor));
      setOutput('internalPostage', formatter.format(postage));
      setOutput('internalPackaging', formatter.format(packaging));
      setOutput('internalHandling', formatter.format(handling));
      setOutput('processorFee', formatter.format(processorFee));
      setOutput('marginLabel', `${Number((marginRate * 100).toFixed(1))}%`);
      setOutput('internalComplexity', `${complexity.toFixed(2)}x`);
      setOutput('trueCost', formatter.format(trueCost));
      setOutput('sellingPrice', formatter.format(total));
      setOutput('internalPerUnit', formatter.format(perUnit));
      setOutput('grossProfit', formatter.format(grossProfit));
      setOutput('actualMargin', `${actualMargin.toFixed(1)}%`);

      setRow('[data-design-field]', designIncluded);
      setRow('[data-calc-design-row]', designIncluded);
      setRow('[data-shipping-fields]', shippingEnabled);
      setRow('[data-calc-shipping-row]', shippingEnabled);
      setRow('[data-calc-customer-row]', customerName !== '—');

      const notesOutput = calculator.querySelector('[data-calc-output="projectNotes"]');
      if (notesOutput) {
        notesOutput.hidden = !projectNotes;
      }

      const marginWarning = calculator.querySelector('[data-calc-margin-warning]');
      if (marginWarning) {
        marginWarning.hidden = !belowTargetMargin;
        marginWarning.textContent = belowTargetMargin
          ? `Internal warning: this quote produces ${actualMargin.toFixed(1)}% gross margin, below the ${targetMarginPercent.toFixed(1)}% target.`
          : '';
      }
    }

    function removeImage() {
      state.imageDataUrl = '';
      state.imageName = '';

      if (imageInput) {
        imageInput.value = '';
      }

      if (imagePreview) {
        imagePreview.removeAttribute('src');
      }

      if (imagePreviewWrap) {
        imagePreviewWrap.hidden = true;
      }

      if (imageError) {
        imageError.hidden = true;
        imageError.textContent = '';
      }
    }

    function handleImage(event) {
      const file = event.target.files?.[0];

      if (!file) {
        removeImage();
        return;
      }

      const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];

      if (!allowedTypes.includes(file.type) || file.size > 10 * 1024 * 1024) {
        removeImage();
        if (imageError) {
          imageError.textContent = file.size > 10 * 1024 * 1024
            ? 'Please choose an image smaller than 10 MB.'
            : 'Please choose a PNG, JPG, or WebP image.';
          imageError.hidden = false;
        }
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        const temporaryImage = new Image();
        temporaryImage.onload = () => {
          const scale = Math.min(1, 1600 / Math.max(temporaryImage.naturalWidth, temporaryImage.naturalHeight));
          const canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(temporaryImage.naturalWidth * scale));
          canvas.height = Math.max(1, Math.round(temporaryImage.naturalHeight * scale));
          const context = canvas.getContext('2d');

          if (!context) {
            return;
          }

          context.fillStyle = '#ffffff';
          context.fillRect(0, 0, canvas.width, canvas.height);
          context.drawImage(temporaryImage, 0, 0, canvas.width, canvas.height);
          state.imageDataUrl = canvas.toDataURL('image/jpeg', 0.86);
          state.imageName = file.name;

          if (imagePreview) {
            imagePreview.src = state.imageDataUrl;
          }
          if (imageName) {
            imageName.textContent = file.name;
          }
          if (imagePreviewWrap) {
            imagePreviewWrap.hidden = false;
          }
          if (imageError) {
            imageError.hidden = true;
          }
        };
        temporaryImage.src = String(reader.result);
      };
      reader.readAsDataURL(file);
    }

    function safeFilename(value) {
      const cleaned = value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      return cleaned || '3d-printing-quote';
    }

    function generatePdf(view) {
      calculate();

      if (!window.jspdf?.jsPDF || !state.values) {
        showCartToast('The PDF tool is still loading. Please try again in a moment.', 'error');
        return;
      }

      const values = state.values;
      const doc = new window.jspdf.jsPDF({ unit: 'mm', format: 'letter' });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const margin = 18;
      const contentWidth = pageWidth - margin * 2;
      let y = 0;

      function addFooter() {
        doc.setDrawColor(225, 225, 225);
        doc.line(margin, pageHeight - 15, pageWidth - margin, pageHeight - 15);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(95, 95, 95);
        doc.setFontSize(7.5);
        doc.text('Generated locally in your browser at linebossfilament.com. No project data was uploaded or stored.', margin, pageHeight - 9);
      }

      function newPageIfNeeded(requiredHeight = 12) {
        if (y + requiredHeight > pageHeight - 22) {
          addFooter();
          doc.addPage();
          y = 20;
        }
      }

      function addLine(label, amount, detail = '') {
        newPageIfNeeded(detail ? 15 : 9);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(38, 38, 38);
        doc.setFontSize(9.5);
        doc.text(label, margin, y);
        doc.text(amount, pageWidth - margin, y, { align: 'right' });
        y += 4.5;

        if (detail) {
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(105, 105, 105);
          doc.setFontSize(8);
          const detailLines = doc.splitTextToSize(detail, contentWidth - 8);
          doc.text(detailLines, margin, y);
          y += detailLines.length * 4 + 2;
        } else {
          y += 3;
        }

        doc.setDrawColor(232, 232, 232);
        doc.line(margin, y, pageWidth - margin, y);
        y += 5;
      }

      function pdfMoney(amount) {
        return `${values.currency} ${amount.toFixed(2)}`;
      }

      doc.setFillColor(247, 92, 24);
      doc.rect(0, 0, pageWidth, 25, 'F');
      doc.setTextColor(20, 16, 14);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(17);
      doc.text('LINEBOSS', margin, 16);
      doc.setFontSize(8);
      doc.text(view === 'internal' ? 'INTERNAL COST SHEET' : 'CUSTOMER QUOTE', pageWidth - margin, 16, { align: 'right' });
      y = 38;

      doc.setTextColor(28, 28, 28);
      doc.setFontSize(18);
      doc.text(doc.splitTextToSize(values.projectName, contentWidth), margin, y);
      y += 10;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8.5);
      doc.setTextColor(90, 90, 90);
      doc.text(`Quote ${state.quoteNumber}  |  ${new Date().toLocaleDateString()}  |  ${values.projectTypeLabel}  |  Qty ${values.quantity}`, margin, y);
      y += 6;

      if (values.customerName !== '—') {
        doc.text(`Prepared for: ${values.customerName}`, margin, y);
        y += 6;
      }

      if (state.imageDataUrl) {
        const properties = doc.getImageProperties(state.imageDataUrl);
        const maxWidth = 64;
        const maxHeight = 42;
        const scale = Math.min(maxWidth / properties.width, maxHeight / properties.height);
        const imageWidth = properties.width * scale;
        const imageHeight = properties.height * scale;
        newPageIfNeeded(imageHeight + 8);
        doc.addImage(state.imageDataUrl, 'JPEG', margin, y, imageWidth, imageHeight, undefined, 'FAST');
        y += imageHeight + 7;
      }

      if (view === 'customer') {
        addLine('Material', pdfMoney(values.materialCharge), `${Math.round(values.grams)} g`);
        addLine('Production Services', pdfMoney(values.productionCharge), durationLabel(values.printHours));
        if (values.designIncluded) {
          addLine('Design Services', pdfMoney(values.designCharge), decimalHoursLabel(values.designHours));
        }
        addLine('Project Preparation & Finishing', pdfMoney(values.handsCharge), `${Math.round(values.handsMinutes)} min`);
        addLine('Project Complexity', values.complexityLabel, values.complexityReason);
        if (values.shippingEnabled) {
          addLine('Shipping & Handling', pdfMoney(values.shippingCharge), 'Combined delivery and processing');
        }

        newPageIfNeeded(28);
        doc.setFillColor(250, 244, 239);
        doc.roundedRect(margin, y, contentWidth, 19, 2, 2, 'F');
        doc.setTextColor(43, 36, 32);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10);
        doc.text('PROJECT TOTAL', margin + 6, y + 12);
        doc.setFontSize(17);
        doc.text(pdfMoney(values.total), pageWidth - margin - 6, y + 12, { align: 'right' });
        y += 27;

        addLine('Estimated price per unit', pdfMoney(values.perUnit), `Based on a batch quantity of ${values.quantity}`);

        if (values.projectNotes) {
          newPageIfNeeded(16);
          doc.setFontSize(9);
          doc.setTextColor(45, 45, 45);
          doc.text('PROJECT NOTES', margin, y);
          y += 5;
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(85, 85, 85);
          const noteLines = doc.splitTextToSize(values.projectNotes, contentWidth);
          doc.text(noteLines, margin, y);
          y += noteLines.length * 4 + 5;
        }

        newPageIfNeeded(20);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8);
        doc.setTextColor(100, 100, 100);
        const disclaimer = 'Estimate only. Final pricing may change after file review, printability checks, quantity confirmation, material availability, and delivery requirements.';
        doc.text(doc.splitTextToSize(disclaimer, contentWidth), margin, y);
      } else {
        addLine('Material cost', pdfMoney(values.materialCost), `${Math.round(values.grams)} g`);
        addLine('Machine wear allocation', pdfMoney(values.machineWear));
        addLine('Utility allocation', pdfMoney(values.utilities));
        addLine('Maintenance reserve', pdfMoney(values.maintenance));
        addLine('Failure / reprint reserve', pdfMoney(values.failureReserve));
        addLine('Protected production value', pdfMoney(values.protectedProduction), durationLabel(values.printHours));
        addLine('Design labor', pdfMoney(values.designLabor));
        addLine('Hands-on labor', pdfMoney(values.handsLabor));
        if (values.shippingEnabled) {
          addLine('Postage', pdfMoney(values.postage));
          addLine('Packaging', pdfMoney(values.packaging));
          addLine('Handling', pdfMoney(values.handling));
          addLine('Payment / platform fee', pdfMoney(values.processorFee));
        }
        addLine('Pricing settings', `${(values.marginRate * 100).toFixed(1)}% margin`, `${values.complexity.toFixed(2)}x complexity`);
        addLine('True company cost', pdfMoney(values.trueCost));
        addLine('Customer selling price', pdfMoney(values.total));
        addLine('Customer price per unit', pdfMoney(values.perUnit), `Batch quantity: ${values.quantity}`);
        addLine('Gross profit', pdfMoney(values.grossProfit), `${values.actualMargin.toFixed(1)}% actual gross margin`);
        if (values.belowTargetMargin) {
          addLine(
            'Internal margin warning',
            `${values.actualMargin.toFixed(1)}% actual`,
            `Below the ${(values.marginRate * 100).toFixed(1)}% target.`,
          );
        }
      }

      addFooter();
      doc.save(`${safeFilename(values.projectName)}-${view}-${state.quoteNumber.toLowerCase()}.pdf`);
    }

    function handleCalculatorInteraction() {
      if (!calculatorStarted) {
        calculatorStarted = true;
        publishLineBossEvent('lineboss_calculator_started', { path: window.location.pathname });
      }
      calculate();
    }

    form.addEventListener('input', handleCalculatorInteraction);
    form.addEventListener('change', handleCalculatorInteraction);
    form.addEventListener('reset', () => {
      window.requestAnimationFrame(() => {
        removeImage();
        state.quoteNumber = createQuoteNumber();
        calculate();
      });
    });

    imageInput?.addEventListener('change', handleImage);
    imageRemove?.addEventListener('click', removeImage);

    calculator.querySelectorAll('[data-calculator-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const activeView = tab.dataset.calculatorTab;

        calculator.querySelectorAll('[data-calculator-tab]').forEach((candidate) => {
          candidate.setAttribute('aria-selected', String(candidate === tab));
        });
        calculator.querySelectorAll('[data-calculator-view]').forEach((view) => {
          view.hidden = view.dataset.calculatorView !== activeView;
        });
      });
    });

    calculator.querySelectorAll('[data-calculator-pdf]').forEach((button) => {
      button.addEventListener('click', () => {
        publishLineBossEvent('lineboss_calculator_pdf', { view: button.dataset.calculatorPdf });
        generatePdf(button.dataset.calculatorPdf);
      });
    });

    calculate();
  });
}

function initTheme() {
  initMobileMenu();
  initDesktopSubmenus();
  initEyebrowRotators();
  initContactFormFeedback();
  initGridLightSurfaces();
  initParallaxMedia();
  initProductGalleries();
  initVariantPills();
  initCommercialLicenseProducts();
  initAjaxProductForms();
  initStarterCartForms();
  initCartDiscountValidation();
  initBlogHub();
  initLaunchCountdowns();
  initSlicerSettings();
  initCartCountRefresh();
  initPolicyPage();
  initAccountSessionModal();
  initPricingCalculators();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTheme, { once: true });
} else {
  initTheme();
}
